module.exports = __webpack_public_path__ + "static/1seater_4k-bae18cb51736c993340e55f9efa311e4.webp";